export default __webpack_public_path__ + "static/media/img-8.16b25866.png";